// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1ANjo","title":"AfterFrontImage_title__19FLV"};